import { createStyles } from '@mantine/core';

import { getCommonStyles } from './SubHeader.common.styles';

const EMBEDDED_SUB_HEADER_HEIGHT = 114;
const EMBEDDED_SUB_HEADER_HEIGHT_NO_NAV = 80;

const useEmbeddedStyles = createStyles(
  (
    theme,
    {
      hasWidget,
      hasSubMenuItems,
    }: {
      hasWidget?: boolean;
      hasSubMenuItems?: boolean;
    }
  ) => ({
    subHeaderContainer: {
      position: 'relative',
      height: hasSubMenuItems ? EMBEDDED_SUB_HEADER_HEIGHT : EMBEDDED_SUB_HEADER_HEIGHT_NO_NAV,
      zIndex: theme.other.zIndex.subHeader,
    },

    subHeaderContent: {
      position: 'relative',
      zIndex: 1,
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: hasWidget ? '1fr 1fr' : '1fr',
      gridTemplateRows: hasSubMenuItems ? 'auto 50px' : '1fr',
      alignItems: hasSubMenuItems ? 'end' : 'center',
      padding: `0 ${theme.other.spacing._24}px`,
      width: '100%',
      height: '100%',
      maxWidth: theme.other.layout.maxWidth,
      color: theme.white,

      [theme.fn.smallerThan('sm')]: {
        padding: `0 ${theme.other.spacing._16}px`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: hasSubMenuItems ? 'flex-end' : 'center',
        gap: theme.other.spacing._8,
      },
    },

    subHeaderTitle: {
      marginTop: 0,
      marginBottom: hasSubMenuItems ? theme.other.spacing._8 : 0,
      color: theme.white,
      fontSize: 28,
      fontStyle: 'normal',
      lineHeight: '32px',
      fontWeight: 700,
      letterSpacing: '-0.02em',

      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },

    subHeaderWidget: {
      color: theme.white,
      fontSize: 28,
      gridColumn: '2 / 2',
      gridRow: '1 / span 2',
      alignSelf: 'center',
      justifySelf: 'end',

      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.other.spacing._48,

      [theme.fn.smallerThan('md')]: {
        gap: theme.other.spacing._24,
      },

      [theme.fn.smallerThan('sm')]: {
        width: '100%',
        justifyContent: 'space-between',
        gap: theme.other.spacing._16,
        order: -1,
        marginBottom: theme.other.spacing._8,
      },
    },

    widgetColumn: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'center',
      gap: 0,
      whiteSpace: 'nowrap',

      [theme.fn.smallerThan('sm')]: {
        alignItems: 'flex-start',
      },
    },

    widgetActionButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 44,
      height: 44,
      borderRadius: '50%',
      backgroundColor: theme.colors.gray2[6],
      color: theme.white,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
      flexShrink: 0,

      '&:hover': {
        backgroundColor: theme.colors.gray2[5],
      },
    },

    widgetDivider: {
      width: 1,
      height: 48,
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      marginLeft: -theme.other.spacing._16,
      marginRight: -theme.other.spacing._24,

      [theme.fn.smallerThan('md')]: {
        marginLeft: -theme.other.spacing._8,
        marginRight: -theme.other.spacing._12,
      },

      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },

    ...getCommonStyles(theme),
  })
);

export default useEmbeddedStyles;
